export * from 'components/Global/Modal/styled.Modal'
